import { combineEpics } from 'redux-observable';
import collections from './collections';
import pages from './pages';
import schedule from './schedule';
import auth from './auth';

export default combineEpics(collections, pages, schedule, auth);



// WEBPACK FOOTER //
// ./src/epics/index.js